import { request } from '@/service/request';
import FApi from "./type";

/** 消息表-列表查询(根据消息类型) */
export function fetchGetUserMsg(params: FApi.SiteMailSearchParams) {
  return request<FApi.SiteMailList>({
    url: '/ys-digital-commerce/message/ysUserMsg/list/2',
    method: 'get',
    params
  });
}

/* 消息表-通过id查询 */
export function fetchGetUserMsgQueryById(params: { id: string }) {
  return request<Api.Common.CommonEmpty>({
    url: '/ys-digital-commerce/message/ysUserMsg/queryById',
    method: 'get',
    params
  });
}

/* 消息表-批量标记已读 */
export function fetchGetMarkReadBatch(params: { ids: string }) {
  return request<Api.Common.CommonEmpty>({
    url: '/ys-digital-commerce/message/ysUserMsg/markReadBatch',
    method: 'put',
    params
  });
}

/* 消息表-标记已读 */
export function fetchGetMarkRead(params: { id: string }) {
  return request<Api.Common.CommonEmpty>({
    url: '/ys-digital-commerce/message/ysUserMsg/markRead',
    method: 'put',
    params
  });
}
